
const CalendarColors = new Map([
    ['offWork', '#f0f0f0'],
    ['workDay', '#a3a3a3'],
    ['workEntry', '#7a7a7a'],
    ['holiday', '#8CC5E1'],
    ['closingDay', '#B6DBED'],
    ['today', '#EBF6FF'],
]);

export default CalendarColors
